import { useRef } from "react";
import { useDay } from "@datepicker-react/hooks";
import { useAscDatePickerPopoverContext } from "../AscDatePickerPopoverContext/AscDatePickerPopoverContext";
import styles from "./AscDatePickerPopoverDayView.module.scss";
import classNames from "classnames";
import weekday from "dayjs/plugin/weekday";
import dayjs from "dayjs";
dayjs.extend(weekday);
interface AscDatePickerPopoverDayViewProps {
  dayLabel: string;
  date: Date;
  activeMonth: boolean;
  range?: boolean;
}
export default function AscDatePickerPopoverDayView({
  dayLabel,
  date,
  activeMonth,
  range,
}: AscDatePickerPopoverDayViewProps) {
  const dayRef = useRef(null);
  const {
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    isStartDate,
    isEndDate,
    onDateSelect,
    onDateFocus,
    onDateHover,
    firstDayOfWeek,
  } = useAscDatePickerPopoverContext();
  const {
    isSelected,
    isWithinHoverRange,
    disabledDate,
    onClick,
    onKeyDown,
    onMouseEnter,
    tabIndex,
  } = useDay({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef,
  });

  if (!dayLabel) {
    return <div />;
  }

  return (
    <div className={styles.wrapper}>
      <button
        className={classNames(styles.ground, {
          [styles.isSelected]: isSelected || isWithinHoverRange,
          [styles.isStartDate]: isStartDate(date),
          [styles.isEndDate]: isEndDate(date),
          [styles.isDisabled]: disabledDate,
          [styles.activeMonth]: activeMonth,
          [styles.isFirstDayOfWeek]: dayjs(date).weekday() === firstDayOfWeek,
          [styles.isLastDayOfWeek]:
            dayjs(date).weekday() === (firstDayOfWeek + 6) % 7,
          [styles.isRange]: range,
        })}
        onClick={onClick}
        onKeyDown={onKeyDown}
        onMouseEnter={onMouseEnter}
        tabIndex={tabIndex}
        type="button"
        ref={dayRef}
      >
        {dayLabel?.toLocaleString()}
      </button>
    </div>
  );
}
